import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
    dialogPaper: {
        width: "100%",
    },
    buttons: {
        justifyContent: "space-between",
    },
    greenFont: {
        fontSize: "14px",
        fontWeight: "400",
        color: theme.palette.success.main,
    },

    redFont: {
        fontSize: "14px",
        fontWeight: "400",
        color: theme.palette.error.main,
    },

}))

export default styles
